module.exports = __webpack_public_path__ + "img/stamp-checked.f573fcbb.png";